// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"MessageCustom_messageContainer__2zOWR","message":"MessageCustom_message__2Iki1","messageLast":"MessageCustom_messageLast__2fOgc"};